const icons = {
    'ok': '<svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="1.5" width="57" height="57" rx="28.5" stroke="#25BC69" stroke-width="3"/><path d="M21.5 28L28.5 35L40.5 23" stroke="#25BC69" stroke-width="3" stroke-linecap="round"/></svg>'
}

export const modalBase = (header, text, icon = null) => {
    const createDiv = (classList, innerHtml = null) => {
        const newDiv = document.createElement("div")
        newDiv.classList.add(classList)
        if(innerHtml) {
            newDiv.innerHTML = innerHtml
        }
        return newDiv;
    }

    const modal = createDiv('po-info-modal__modal')
    const close = createDiv('po-info-modal__close', '<svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 7L6.5 1" stroke="#1E385B" stroke-linecap="round"/><path d="M6.5 7L0.5 1" stroke="#1E385B" stroke-linecap="round"/></svg>')
    modal.appendChild(close)
    if(icon) {
        modal.appendChild(createDiv("po-info-modal__icon", icons[icon]))
    }
    modal.appendChild(createDiv("po-info-modal__header", header))
    modal.appendChild(createDiv("po-info-modal__text", text))

    const modalWrapper = createDiv('po-info-modal')
    modalWrapper.appendChild(modal)

    close.addEventListener("click", () => {
        modalWrapper.remove()
    })

    modalWrapper.addEventListener("click", (e) => {
        if(e.target === modalWrapper) {
            modalWrapper.remove()
        }
    })

    document.body.appendChild(modalWrapper)
}